import request from "@/config/axios";

const mode = 'basedata'; // 对应config里的oDomains的key

// 获取围栏列表
export function getStudentFenceList(params) {
  return request({
    url: '/v1/fence/getStudentFenceList',
    method: 'GET', 
    mode,
    params,
  })
}
// 获取围栏信息
export function getStudentFenceInfo(params) {
  return request({
    url: '/v1/fence/getStudentFenceInfo',
    method: 'GET',
    mode, 
    params,
  })
}
// 家长添加学生电子围栏信息
export function insertStudentFence(data) {
  return request({
    url: '/v1/fence/addStudentFence',
    method: 'POST',
    mode,
    data
  })
}
// 家长更新学生电子围栏信息
export function updateStudentFence(data) {
  return request({
    url: '/v1/fence/updateStudentFence',
    method: 'POST',
    mode,
    data
  })
}
// 删除电子围栏信息
export function deleteFence(params) {
  return request({
    url: '/v1/fence/deleteStudentFence',
    method: 'POST',
    mode,
    params
  })
}
// 7.1.靠一靠消息查询接口
export function pageQuery(data) {
  return request({
    url: '/v1/eventMsg/pageQuery',
    method: 'POST',
    mode,
    data
  })
}
// 查询通讯录列表
export function listQuery(params) {
  return request({
    url: '/v1/contacts/listQuery',
    method: 'post',
    mode,
    params
  })
}
// 添加通讯录
export function contactsAdd(data) {
  return request({
    url: '/v1/contacts/add',
    method: 'post',
    noLoad:true,
    mode,
    data
  })
}
// 编辑通讯录
export function contactsUpdate(data) {
  return request({
    url: '/v1/contacts/update',
    method: 'post',
    mode,
    data
  })
}
// 删除通讯录
export function contactsDelete(data) {
  return request({
    url: '/v1/contacts/delete',
    method: 'post',
    noLoad:true,
    mode,
    data
  })
}
// 同步通讯录
export function sendContact(params) {
  return request({
    url: '/v1/contacts/sendContact',
    method: 'post',
    mode,
    params
  })
}

// 获取亲情关系下拉列表
export function getKinshipList(params) {
  return request({
    url: '/v1/parent/getKinshipList',
    method: 'GET', 
    mode,
    params,
  })
}

// 设置学生定位模式
export function setting(data) {
  return request({
    url: '/v1/location/setting',
    method: 'post',
    mode,
    data
  })
}
// 获取学生定位模式
export function getSetting(params) {
  return request({
    url: '/v1/location/getSetting',
    method: 'get',
    mode,
    params
  })
}
// 根据学生id获取上课模式设置
export function getClassPatternByStudentId(params) {
  return request({
    url: '/v1/classPattern/getClassPatternByStudentId',
    method: 'get',
    mode,
    params
  })
}
// 我的页面获取上课模式是否开启
export function getClassPatternStatusByStudentId(params) {
  return request({
    url: '/v1/classPattern/getClassPatternStatusByStudentId',
    method: 'get',
    mode,
    params
  })
}
// 更新学生上课时间
export function updateClassPatternTime(data) {
  return request({
    url: '/v1/classPattern/updateClassPatternTime',
    method: 'post',
    mode,
    data
  })
}
// 设置学生的上课模式状态
export function updateStatus(data) {
  return request({
    url: '/v1/classPattern/updateStatus',
    method: 'post',
    mode,
    data
  })
}
// 接收通话记录数据
export function contactsList(data) {
  return request({
    url: '/v1/contacts/record/pageQuery',
    method: 'post',
    mode,
    data
  })
}
// 获得闹钟列表
export function getAlarmClockList(params) {
  return request({
    url: '/v1/alarmClock/getAlarmClockList',
    method: 'get',
    mode,
    params
  })
}
// 修改闹钟状态
export function modifyStatus(params) {
  return request({
    url: '/v1/alarmClock/modifyStatus',
    method: 'post',
    mode,
    params
  })
}
// 新增闹钟
export function clockAdd(data) {
  return request({
    url: '/v1/alarmClock/operation/add',
    method: 'post',
    mode,
    data
  })
}
// 删除闹钟
export function clockDelete(params) {
  return request({
    url: '/v1/alarmClock/operation/delete',
    method: 'post',
    mode,
    params
  })
}
// 编辑闹钟
export function clockUpdate(data) {
  return request({
    url: '/v1/alarmClock/operation/update',
    method: 'post',
    mode,
    data
  })
}

// 查询挂失状态
export function getLossStatus(params) {
  return request({
    url: '/v1/student/getLossStatus',
    method: 'get',
    mode,
    params
  })
}
// 下发挂失指令
export function loss(params) {
  return request({
    url: '/v1/student/loss',
    method: 'post',
    mode,
    params
  })
}
// 下发取消挂失指令
export function unLoss(params) {
  return request({
    url: '/v1/student/unLoss',
    method: 'post',
    mode,
    params
  })
}

// 获取设备应用列表
export function versionQuery(params,noLoad) {
  return request({
    url: '/v1/firmware/getAppByFirmwareVersion',
    method: 'GET',
    mode,
    params,
    noLoad:noLoad,
  })
}

// 获取设备休眠信息
export function getDormancyInfo(params) {
  return request({
    url: '/v1/device/sleep/getDeviceSleep',
    method: 'GET',
    mode,
    params
  })
}

// 修改设备休眠时间
export function sleepUpdate(data) {
  return request({
    url: '/v1/device/sleep/update',
    method: 'post',
    mode,
    data
  })
}

// 修改设备休眠状态
export function sleepUpdateStatus(data) {
  return request({
    url: '/v1/device/sleep/updateStatus',
    method: 'post',
    mode,
    data
  })
}
